<template lang="pug"> 
  v-btn( 
    type="submit"
    :disabled='loading || disabled'
    :loading='loading'
    :color="colorDefault"
    :block="block"
    :dark="!loading"
    depressed 
    large
    style="border-radius:10px;"
    @click='$emit("click")'
  )
    slot

</template>
<script>
import ButtonMixin from '@/mixins/Button'
export default {
  mixins : [ButtonMixin],
  computed: {
    colorDefault () {
      return this.color || 'var(--bg-main-color-2-v2)'
    }
  }
}
</script>